import { useAppContext } from "../../../../_context";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormSection from "./FormSection";

const SignupFullForm = ({ setMessageSent }) => {
  const [{ tx }] = useAppContext();

  return (
    <>
      <section className="title-section">
        <Container>
          <Row>
            <Col xs={12} className="mx-auto text-center">
              <h1>{tx["Register your club/venue on RacketPal"]}</h1>
              <p>
                {
                  tx[
                    "Please fill in all the details below. The ones with * are mandatory."
                  ]
                }
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <FormSection setMessageSent={setMessageSent} />
    </>
  );
};

export default SignupFullForm;
